import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const UserRolesPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.UserRoles}
        fetchRecordsUrl={AdminReqUrls.admin__userRoles__mainPage_fetch_recordList}
    />)
});
export default UserRolesPage;
